{
  "refinement.intake.acceptAll": "Tümünü incele",
  "refinement.intake.acceptSelected": "Seçilenleri incele ({{count}})",
  "refinement.intake.applied": "{{count}} sonuç uygulandı",
  "refinement.intake.back": "Geri",
  "refinement.intake.cancel": "Vazgeç",
  "refinement.intake.classification.automation": "Otomasyon taslağı",
  "refinement.intake.classification.linked_project_area": "Bağlı proje alanı",
  "refinement.intake.classification.rationale": "Gerekçe",
  "refinement.intake.clearMatch": "Bu eşleşmeyi kullanma",
  "refinement.intake.clarify": "Netleştir",
  "refinement.intake.confidence": "%{{value}} güven",
  "refinement.intake.confirmApply": "Bu değişiklikleri uygula",
  "refinement.intake.createSplit": "Yeni triyajı oluştur",
  "refinement.intake.deadline": "son tarih",
  "refinement.intake.edit": "Düzenle",
  "refinement.intake.editTitle": "Önerilen başlık",
  "refinement.intake.error.generic": "Bu işlem tamamlanamadı. İnceleme seçimlerin hâlâ burada.",
  "refinement.intake.exactChanges": "Kesin değişiklikler",
  "refinement.intake.intentState.accepted": "Uygulandı",
  "refinement.intake.intentState.pending": "Bekliyor",
  "refinement.intake.intentState.rejected": "Reddedildi",
  "refinement.intake.keyboardHelp": "Klavye: J/K öneriler arasında gider, Boşluk seçer, A tümünü inceler, R etkin öneriyi reddeder.",
  "refinement.intake.lede": "Exognitos'un ne anladığını incele. Kesin değişiklikleri onaylayana kadar hiçbir şey gerçek kayda dönüşmez.",
  "refinement.intake.link": "Bağla",
  "refinement.intake.linked": "bağlı",
  "refinement.intake.loadError": "Bu triyaj yüklenemedi",
  "refinement.intake.matches": "Olası mevcut eşleşmeler",
  "refinement.intake.merge": "Birleştir",
  "refinement.intake.noEffects": "Herhangi bir değişiklik tanımlanmadı.",
  "refinement.intake.noExtraAuthority": "Ek yetki gerekmiyor",
  "refinement.intake.noTiming": "Kesin tarih veya saat eklenmeyecek.",
  "refinement.intake.openResult": "Sonucu aç",
  "refinement.intake.optional": "İsteğe bağlı",
  "refinement.intake.previewDescription": "{{intents}} öneri, {{effects}} kesin etki. Bu önizleme hiçbir şey yazmadı.",
  "refinement.intake.previewTitle": "Uygulamaya hazır",
  "refinement.intake.proposals": "Öneriler",
  "refinement.intake.proposalsDescription": "Her öneriyi ayrı ayrı düzenleyebilir, eşleştirebilir, kabul veya reddedebilirsin.",
  "refinement.intake.questions": "Netleştirme gerekiyor",
  "refinement.intake.questionsDescription": "Yalnızca bildiklerini yanıtla. Belirsiz tarihler ve düşük güvenli yorumlar uygulanmadan bekler.",
  "refinement.intake.receipt": "Makbuz",
  "refinement.intake.receiptDescription": "{{date}} tarihinde {{count}} sonuç uygulandı.",
  "refinement.intake.recurring": "tekrarlanan",
  "refinement.intake.refresh": "Son sürümü yükle",
  "refinement.intake.reject": "Reddet",
  "refinement.intake.reminder": "{{count}} dk hatırlatma",
  "refinement.intake.retry.answers": "Yanıtları yeniden dene",
  "refinement.intake.retry.apply": "Uygulamayı yeniden dene",
  "refinement.intake.retry.edit": "Düzenlemeyi yeniden dene",
  "refinement.intake.retry.preview": "Önizlemeyi yeniden dene",
  "refinement.intake.retry.reject": "Reddetmeyi yeniden dene",
  "refinement.intake.retry.resolution": "Eşleşmeyi yeniden dene",
  "refinement.intake.retry.split": "Ayırmayı yeniden dene",
  "refinement.intake.retry.undo": "Geri almayı yeniden dene",
  "refinement.intake.revision": "sürüm {{value}}",
  "refinement.intake.save": "Kaydet",
  "refinement.intake.saveAnswers": "Yanıtları kaydet",
  "refinement.intake.scheduled": "planlı",
  "refinement.intake.selectAll": "Bekleyen tüm önerileri seç",
  "refinement.intake.selectIntent": "{{title}} önerisini seç",
  "refinement.intake.split": "Ayır",
  "refinement.intake.splitDisabled": "Ayırma işlemini herhangi bir öneriyi uygulamadan veya reddetmeden önce yap.",
  "refinement.intake.splitHint": "Her ayrı düşünceyi kendi satırına koy. Yeni triyaj bu taslağın yerini alır; uygulanmış işler asla çoğaltılmaz.",
  "refinement.intake.splitLabel": "Düşünceleri ayır",
  "refinement.intake.status.applied": "Uygulandı",
  "refinement.intake.status.draft": "İncelemeye hazır",
  "refinement.intake.status.expired": "Süresi doldu",
  "refinement.intake.status.needsInput": "Netleştirme gerekiyor",
  "refinement.intake.status.partiallyApplied": "Kısmen uygulandı",
  "refinement.intake.status.rejected": "Reddedildi",
  "refinement.intake.status.superseded": "Yeni bir triyajla değiştirildi",
  "refinement.intake.timing": "Tarih, saat ve tekrar",
  "refinement.intake.title": "Triyaj",
  "refinement.intake.undo": "Güvenle geri al",
  "refinement.intake.undone": "Bu uygulamanın kayıtları güvenle Çöp Kutusu'na taşındı.",
  "refinement.intake.quick.description": "Bir şey Görev, Proje, Not veya takvim kaydı olmadan önce yapılandırılmış öneriyi incele.",
  "refinement.intake.quick.sort": "Benim için düzenle",
  "refinement.intake.quick.sorted": "Triyajın hazır"
}
